import React from 'react';
import styled from '../../styled';
import * as Icons from '../icons';
const MenuUrlIcon = styled.div `
  width: 1.75rem;
  height: 1.75rem;
  box-sizing: border-box;
  border: 1px solid #e6eaf0;
  border-radius: 4px;
  background: url(${({ icon }) => icon}) no-repeat;
  background-size: cover;
  background-position: center;
`;
const TabIcon = ({ icon, iconType = 'KEY' }) => {
    if (iconType !== 'KEY')
        return React.createElement(MenuUrlIcon, { icon: icon });
    const [name, category = 'Outline'] = icon.split('/').reverse();
    const MenuIcon = Icons[category] && Icons[category][name];
    return MenuIcon && React.createElement(MenuIcon, { size: "MEDIUM", color: "INK_400" });
};
export default TabIcon;
//# sourceMappingURL=TabIcon.js.map